import React from 'react';
import ReactPlayer from 'react-player';
const VideoPlayer = (props) => {
	const { 
		url,
		controls = true,
		onEnded = () => console.log('ended'),
		autoPlay = false,
		playsInline = false,
		pip = false,
	} = props;

	const extraProps = {};
	// if(autoPlay)
	return (
		<div style={{
			position: 'relative',
			paddingTop: '56.25%',
			backgroundColor: 'grey',
			marginBottom: 12,
		}}>
			<ReactPlayer
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
				}}
				width='100%'
				height='100%'
				url={url}
				controls={controls}
				playing={autoPlay}
				playsInline={playsInline}
				pip={pip}
				onEnded={onEnded}
				config={{
					youtube: {
						playerVars: {
							rel: 0,
							controls: 1,
							modestbranding: 1,
						},
					},
				}}
			/>
		</div>
	);
};


VideoPlayer.type = 'VideoPlayer';
VideoPlayer.spec = [{
	name: 'VideoPlayer',
	key: 'videoplayer',
	title: 'Videoplayer',
	category: 'layout',
	icon: 'Youtube',
	translatable: ['url'],
	fields: [{
		type: 'TextField',
		label: 'Video URL (youtube or vimeo)',
		name: 'url',
	}],
}];

export default VideoPlayer;